import { Route, BrowserRouter as Router, Routes, Navigate } from "react-router";
import AppLayout from "./layout/AppLayout";
import AuthLayout from "./layout/AuthLayout";
import SignIn from "./pages/AuthPages/SignIn";
import SignUp from "./pages/AuthPages/SignUp";
import Blank from "./pages/Blank";
import Calendar from "./pages/Calendar";
import Ecommerce from "./pages/Dashboard/ECommerce";
import FormElements from "./pages/Forms/FormElements";
import NotFound from "./pages/OtherPage/NotFound";
import BasicTables from "./pages/Tables/BasicTables";
import Alerts from "./pages/UiElements/Alerts";
import Avatars from "./pages/UiElements/Avatars";
import Badges from "./pages/UiElements/Badges";
import Buttons from "./pages/UiElements/Buttons";
import Images from "./pages/UiElements/Images";
import Videos from "./pages/UiElements/Videos";
import ListUser from "./pages/Users/ListUser";
import ListDeck from "./pages/Decks/ListDeck";
import CreateFlashcard from "./pages/Flashcard/CreateFlashcard";
import CreateDeck from "./pages/Decks/CreateDeck";
import ListFlashcardInDeck from "./pages/Decks/ListFlashcardInDeck";
import EditFlashcard from "./pages/Flashcard/EditFlashcard";
import EditDeck from "./pages/Decks/EditDeck";
import ViewUser from "./pages/Users/ViewUser";
import EditUser from "./pages/Users/EditUser";
import ListLeaderboard from "./pages/Leaderboard/ListLeaderboard";
import ListHistoryByDeck from './pages/History/ListHistoryByDeck';
import ListCategories from "./pages/Categories/ListCategories";
import CreateCategories from "./pages/Categories/CreateCategories";
import EditCategory from "./pages/Categories/EditCategory";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CreateAchievement from "./pages/Achievement/CreateAchievement";
import ListAchievements from "./pages/Achievement/ListAchievements";
import EditAchievement from "./pages/Achievement/EditAchievement";
import ListDeckInCategory from "./pages/Decks/ListDeckInCategory";
import ListFlashcard from "./pages/Flashcard/ListFlashcard";
import CreateMostPopular from "./pages/MostPopular/CreateMostPopular";
import CreateSmartFlashcardPicks from "./pages/SmartFlashcardPicks/CreateSmartFlashcardPicks";
import CreateTrendingDecks from "./pages/TrendingDecks/CreateTrendingDecks";
import CreateAdvertisement from "./pages/Advertisement/CreateAdvertisement";
import ListAdvertisement from "./pages/Advertisement/ListAdvertisement";
import EditAdvertisement from "./pages/Advertisement/EditAdvertisement";
import CreateFlashcardWithAI from "./pages/Flashcard/CreateFlashcardWithAI";
import CreatePushNotification from "./pages/PushNotification/CreatePushNotification";
import ListNotificationHistories from "./pages/PushNotification/ListNotificationHistories";
import ViewNotificationHistories from "./pages/PushNotification/ViewNotificationHistories";
import ListSubscriptionPlans from "./pages/SubscriptionPlans/ListSubscriptionPlans";
import CreateSubscriptionPlan from "./pages/SubscriptionPlans/CreateSubscriptionPlan";
import EditSubscriptionPlan from "./pages/SubscriptionPlans/EditSubscriptionPlan";
import ViewSubscriptionPlan from "./pages/SubscriptionPlans/ViewSubscriptionPlan";

export default function App() {
  const token = localStorage.getItem("token");
  return (
    <>
      <ToastContainer
        position="bottom-left"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
        style={{ zIndex: 99999 }}
      />
      <Router>
        <Routes>
          {/* Root redirect */}
          <Route
            path="/"
            element={token ? <Navigate to="/dashboard" /> : <Navigate to="/signin" />}
          />

          {/* Dashboard Layout */}
          {token ? (
            <Route element={<AppLayout />}>
              <Route path="/dashboard" element={<Ecommerce />} />
              {/* Others Page */}
              {/* <Route path="/profile" element={<UserProfiles />} /> */}
              <Route path="/calendar" element={<Calendar />} />
              <Route path="/blank" element={<Blank />} />

              {/* Forms */}
              <Route path="/form-elements" element={<FormElements />} />

              {/* Tables */}
              <Route path="/basic-tables" element={<BasicTables />} />

              {/* User */}
              <Route path="/list-users" element={<ListUser />} />
              <Route path="/list-users/:user_id" element={<ViewUser />} />
              <Route path="/edit-user/:user_id" element={<EditUser />} />

              {/* Decks */}
              <Route path="/list-decks" element={<ListDeck />} />
              <Route path="/list-decks/:category_id" element={<ListDeckInCategory />} />
              <Route path="/create-deck" element={<CreateDeck />} />
              <Route path="/edit-deck/:deck_id" element={<EditDeck />} />

              {/* Flashcards */}
              <Route path="/list-flashcards" element={<ListFlashcard />} />
              <Route path="/list-flashcards/:deck_id" element={<ListFlashcardInDeck />} />
              <Route path="/create-flashcard/:deck_id" element={<CreateFlashcard />} />
              <Route path="/create-flashcard-with-ai/:deck_id" element={<CreateFlashcardWithAI />} />
              <Route path="/edit-flashcard/:flashcard_id" element={<EditFlashcard />} />

              {/* Categories */}
              <Route path="/list-categories" element={<ListCategories />} />
              <Route path="/create-categories" element={<CreateCategories />} />
              <Route path="/edit-category/:category_id" element={<EditCategory />} />

              {/* Leaderboard */}
              <Route path="/list-leaderboard" element={<ListLeaderboard />} />

              {/* History */}
              <Route path="/list-history" element={<ListHistoryByDeck />} />

              {/* Achievement */}
              <Route path="/create-achievement" element={<CreateAchievement />} />
              <Route path="/list-achievements" element={<ListAchievements />} />
              <Route path="/edit-achievement/:achievement_id" element={<EditAchievement />} />

              {/* Ui Elements */}
              <Route path="/alerts" element={<Alerts />} />
              <Route path="/avatars" element={<Avatars />} />
              <Route path="/badges" element={<Badges />} />
              <Route path="/buttons" element={<Buttons />} />
              <Route path="/images" element={<Images />} />
              <Route path="/videos" element={<Videos />} />

              {/* Recommend Decks */}
              <Route path="/most-popular" element={<CreateMostPopular />} />
              <Route path="/smart-flashcard-picks" element={<CreateSmartFlashcardPicks />} />
              <Route path="/trending-decks" element={<CreateTrendingDecks />} />

              {/* Advertisement */}
              <Route path="/create-advertisement" element={<CreateAdvertisement />} />
              <Route path="/list-advertisements" element={<ListAdvertisement />} />
              <Route path="/edit-advertisement/:advertisement_id" element={<EditAdvertisement />} />

              {/* Push Notification */}
              <Route path="/create-push-notification" element={<CreatePushNotification />} />
              <Route path="/list-notification-histories" element={<ListNotificationHistories />} />
              <Route path="/list-notification-histories/:id" element={<ViewNotificationHistories />} />

              {/* Subscription Plans */}
              <Route path="/list-subscription-plans" element={<ListSubscriptionPlans />} />
              <Route path="/create-subscription-plan" element={<CreateSubscriptionPlan />} />
              <Route path="/edit-subscription-plan/:plan_id" element={<EditSubscriptionPlan />} />
              <Route path="/subscription-plans/:plan_id" element={<ViewSubscriptionPlan />} />
            </Route>
          ) : (
            <Route element={<AuthLayout />}>
              <Route path="/signin" element={<SignIn />} />
              <Route path="*" element={<Navigate to="/signin" />} />
            </Route>
          )}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </>
  );
}
